module.exports = __webpack_public_path__ + "static/img/hm.befc05fb.svg";